import { render, staticRenderFns } from "./GallerySlideshow.vue?vue&type=template&id=ba8e6674&"
import script from "./GallerySlideshow.vue?vue&type=script&lang=js&"
export * from "./GallerySlideshow.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports